define('v3/Pages/WayOfWork/ViewModels/WayOfWork.ViewModel',[
	'knockout',
	'lodash',
	'v3/Common/Models/enums',
	'v3/FromV2/localStorageV3Service',
	'v3/Pages/WayOfWork/Services/WayOfWork.Service',
	'v3/Common/Bindings/SvgIcon.Binding',
	'v3/Common/Bindings/Carousel.Binding',
	'v3/FromV2/utils'
], function (ko, _, enums, localStorageV3Service, wayOfWorkService) {
	function WayOfWorkViewModel (currentCountryCode2Letters) {
		var self = this;
		var _slick;
		var defaultCountryCode2Letters = 'Nl';
		self.pageHasVisited = ko.observable(localStorageV3Service.getWowPageHasVisitedLocalStorage());

		self.setWowPageHasVisited = function () {
			localStorageV3Service.setWowPageHasVisitedLocalStorage(true);
			self.pageHasVisited(true);
		};

		self.subjectCategory = ko.observable();
		self.stage = ko.observable();
		self.currentSlickSlide = ko.observable();
		self.progress = ko.observable();
		self.bounds = ko.observable();

		self.subjectCategory.subscribe(function (subjectCategory) {
			if (subjectCategory) {
				wayOfWorkService.getStage(subjectCategory).done(function (stage) {
					self.stage(stage);
					scrollCarouselToActiveStageIfPossible();
				});
				wayOfWorkService.getProgress(subjectCategory).done(function (progress) {
					self.progress(progress);
				});
				wayOfWorkService.getBoundaries(subjectCategory).done(function (bounds) {
					self.bounds(bounds);
				});
			}
		});

		self.showPrevious = ko.observable(false);
		self.showNext = ko.observable(true);
		self.cardsLoaded = ko.observable(false);

		var loadedCardsCount = 0;

		self.wowCardAfterRenderCallback = function () {
			if (self.cards.length === ++loadedCardsCount) {
				self.cardsLoaded(true);
			}
		};

		self.carouselInitCallback = function (slick) {
			_slick = slick;
			scrollCarouselToActiveStageIfPossible();
		};

		self.afterChange = function () {
			self.currentSlickSlide(_slick.currentSlide);
		};

		self.nextCard = function () {
			_slick.slickNext();
		};

		self.previousCard = function () {
			_slick.slickPrev();
		};

		var baseWowUrl = '//s3-eu-west-1.amazonaws.com/staticmedia.snappet.org/wow/';

		function getVideoSources (videoName) {
			return [
				{ src: getVideoUrl((currentCountryCode2Letters || defaultCountryCode2Letters), videoName), type: 'video/mp4' },
				{ src: getVideoUrl(defaultCountryCode2Letters, videoName), type: 'video/mp4' }
			];
		}

		function getVideoUrl (countryCode, videoName) {
			return baseWowUrl + countryCode + '/video/' + videoName + '.mp4';
		}

		function getElearningSource (elearningName) {
			return currentCountryCode2Letters ? baseWowUrl + currentCountryCode2Letters + '/e-learning/' + elearningName + '/index.html'
				: baseWowUrl + defaultCountryCode2Letters + '/e-learning/' + elearningName + '/index.html';
		}

		function scrollCarouselToActiveStageIfPossible () {
			if (_slick && (self.stage() !== undefined)) {
				var activeSlideIndex = _.findIndex(self.cards, function (card) { return card.current(); });
				_slick.goTo(activeSlideIndex);
			}
		}

		function normalize (numerator, denominator) {
			var gcd = function gcd (a, b) {
				return b ? gcd(b, a % b) : a;
			};
			gcd = gcd(numerator, denominator);
			return [numerator / gcd, denominator / gcd];
		}

		self.cards = [wayOfWorkingOneCard(), wayOfWorkingTwoCard(), wayOfWorkingThreeCard()];

		if (Settings.isWayOfWorkMethodFourEnabled) {
			self.cards.push(wayOfWorkingFourCard());
		}

		function getWayOfWorkingPlanMeetingLink (wayOfWorking) {
			if (currentCountryCode2Letters === 'Es') {
				var email = 'mailto:formacion@snappet.org?subject=Quiero saber m{0}s sobre la manera de trabajar {1}'.formatRaw(String.fromCharCode(225), wayOfWorking);
				return email;
			}

			return 'https://snappetgesprek.youcanbook.me/';
		}

		function CardModel (params) {
			this.name = params.name;
			this.icon = params.icon;
			this.headerText = params.headerText;
			this.headerExplanation = params.headerExplanation;
			this.ViewProgress = params.ViewProgress || null;
			this.steps = params.steps || null;
			this.viewVideo = params.viewVideo || null;
			this.planMeeting = params.planMeeting || null;
			this.ELearning = params.ELearning || null;
			this.hasSteps = params.hasOwnProperty('steps');
			this.hasVideo = params.hasOwnProperty('viewVideo') && false;
			this.hasPlanMeeting = params.hasOwnProperty('planMeeting');
			this.hasELearning = params.hasOwnProperty('ELearning');
			this.achieved = params.achieved;
			this.current = params.current;
			this.isCurrentSlideActive = params.isCurrentSlideActive;
			this.videoSources = params.videoSources;
			this.elearningSource = params.elearningSource;
			this.progress = params.progress;
			this.progressText = params.progressText;
			this.target = params.target;
			this.targetText = params.targetText;
		}

		function wayOfWorkingOneCard () {
			return new CardModel({
				name: 'directFeedback',
				icon: 'Lesson',
				headerText: '1. ' + Strings.TeachingWithDirectFeedback,
				headerExplanation: Strings.DirectFeedbackExplanation,
				steps: [Strings.TeachingWithDirectFeedbackStep1, Strings.TeachingWithDirectFeedbackStep2, Strings.TeachingWithDirectFeedbackStep3],
				viewVideo: '#',
				planMeeting: getWayOfWorkingPlanMeetingLink(enums.wayOfWorking.one),
				ELearning: '#',
				ViewProgress: '#',
				achieved: ko.computed(function () { return self.stage() > 0; }),
				current: ko.computed(function () { return self.stage() === 1; }),
				isCurrentSlideActive: ko.computed(function () { return self.currentSlickSlide() === 0; }),
				videoSources: getVideoSources('stage1'),
				elearningSource: getElearningSource('stage1'),
				progress: ko.computed(function () { return self.progress() ? self.progress().numberOfExercises : 0; }),
				targetText: ko.computed(function () {
					return Strings.WoWTargetDirectFeedback.formatEncodeArguments(self.bounds() ? self.bounds().numberOfExercises : 0);
				}),
				target: ko.computed(function () { return self.bounds() ? self.bounds().numberOfExercises : 0; }),
				progressText: Strings.Exercises
			});
		}

		function wayOfWorkingTwoCard () {
			return new CardModel({
				name: 'adaptiveWorking',
				icon: 'Plus',
				headerText: '2. ' + Strings.ProcessOnOwnLevel,
				headerExplanation: Strings.ProcessOwnLevelExplanation,
				steps: [Strings.ProcessOnOwnLevelStep1, Strings.ProcessOnOwnLevelStep2, Strings.ProcessOnOwnLevelStep3],
				viewVideo: '#',
				planMeeting: getWayOfWorkingPlanMeetingLink(enums.wayOfWorking.two),
				ELearning: '#',
				ViewProgress: '#',
				achieved: ko.computed(function () { return self.stage() > 1; }),
				current: ko.computed(function () { return self.stage() === 2; }),
				isCurrentSlideActive: ko.computed(function () { return self.currentSlickSlide() === 1; }),
				videoSources: getVideoSources('stage2'),
				elearningSource: getElearningSource('stage2'),
				progress: ko.computed(function () { return self.progress() ? self.progress().percentageAdaptive : 0; }),
				targetText: ko.computed(function () {
					return Strings.WoWTargetAdaptiveWorking.formatEncodeArguments(self.bounds() ? self.bounds().percentageAdaptive : 0);
				}),
				target: ko.computed(function () { return self.bounds() ? self.bounds().percentageAdaptive : 0; }),
				progressText: '%'
			});
		}

		function wayOfWorkingThreeCard () {
			return new CardModel({
				name: 'workingSets',
				icon: 'LOPackage',
				headerText: '3. ' + Strings.WorkingOnBacklog,
				headerExplanation: Strings.WorkOnBacklogExplanation,
				steps: [Strings.WorkingOnBacklogStep1, Strings.WorkingOnBacklogStep2, Strings.WorkingOnBacklogStep3],
				viewVideo: '#',
				planMeeting: getWayOfWorkingPlanMeetingLink(enums.wayOfWorking.three),
				ELearning: '#',
				ViewProgress: '#',
				achieved: ko.computed(function () { return self.stage() > 2; }),
				current: ko.computed(function () { return self.stage() === 3; }),
				isCurrentSlideActive: ko.computed(function () { return self.currentSlickSlide() === 2; }),
				videoSources: getVideoSources('stage3'),
				elearningSource: getElearningSource('stage3'),
				progress: ko.computed(function () { return self.progress() ? self.progress().numberOfExercisesInWorkingSets : 0; }),
				targetText: ko.computed(function () {
					return Strings.WoWTargetWorkingSets.formatEncodeArguments(self.bounds() ? self.bounds().numberOfExercisesInWorkingSets : 0);
				}),
				target: ko.computed(function () { return self.bounds() ? self.bounds().numberOfExercisesInWorkingSets : 0; }),
				progressText: Strings.Exercises
			});
		}

		function wayOfWorkingFourCard () {
			return new CardModel({
				name: 'extraInstruction',
				icon: 'ExtendedInstruction',
				headerText: '4. ' + Strings.SpecificExtraIntruction,
				headerExplanation: Strings.SpecificExtraInstructionExplanation,
				steps: [Strings.SpecificExtraInstructionStep1, Strings.SpecificExtraInstructionStep2, Strings.SpecificExtraInstructionStep3],
				viewVideo: '#',
				planMeeting: getWayOfWorkingPlanMeetingLink(enums.wayOfWorking.four),
				ELearning: '#',
				ViewProgress: '#',
				achieved: ko.computed(function () { return self.stage() > 3; }),
				current: ko.computed(function () { return self.stage() === 4; }),
				isCurrentSlideActive: ko.computed(function () { return self.currentSlickSlide() === 3; }),
				videoSources: getVideoSources('stage4'),
				elearningSource: getElearningSource('stage4'),
				progress: ko.computed(function () { return self.progress() ? self.progress().numberOfInstructionsSets : 0; }),
				targetText: ko.computed(function () {
					if (self.bounds()) {
						var normalized = normalize(self.bounds().numberOfInstructions * 100, 100);
						return Strings.WoWTargetExtraInstruction.formatEncodeArguments(normalized[0], normalized[1]);
					}
					return '';
				}),

				target: ko.computed(function () { return self.bounds() ? self.bounds().numberOfInstructions : 0; }),
				progressText: Strings.WoWProgressTextExtraInstruction
			});
		}
	}

	return WayOfWorkViewModel;
});
